var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex"},_vm._l((_vm.params.value),function(value){return _c('div',{key:value.id,staticClass:"flagContainer"},[_c('VtFlags',{attrs:{"code":value.language.locale}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }